/* src/services/auth.js */
import api from './api'
import axios from 'axios'

const VAPID_PUBLIC_KEY = process.env.VUE_APP_VAPID_PUBLIC_KEY

export const authService = {

  async login(username, password) {

    try {

      const formData = new FormData()
      formData.append('username', username)
      formData.append('password', password)
      const response = await api.post('/api-token-auth/', formData)
      const token = response.data.token
      localStorage.setItem('user-token', token)
      console.debug("*** DEBUG user-token", token)

      if (window.isSecureContext && ('serviceWorker' in navigator)) {

        this.registerPush().catch(err => console.error("Push failed:", err))
      }

      return response.data
    } 
    catch (error) {

      console.error("Errore durante il login:", error)
      throw error
    }
  },

  async getUserProfile() {

    try {

      const response = await api.get('/booking/auth/user/')
      return response.data
    } 
    catch (error) {

      console.error("Errore recupero profilo:", error)
      throw error
    }
  },

  logout() {

    localStorage.removeItem('user-token')
    localStorage.removeItem('device-registered')
    console.log("Logged out: Token rimosso.")
    window.location.reload() // Opzionale: ricarica per resettare lo stato dell'app
  },


  async registerPush() {

    if (!VAPID_PUBLIC_KEY) {

      console.error("VAPID_PUBLIC_KEY mancante nelle variabili d'ambiente!")
      return
    }

    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {

      return
    }

    try {

      const registration = await navigator.serviceWorker.ready
      const permission = await Notification.requestPermission()

      if (permission !== 'granted') {

        return
      }
      
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
      })

      await api.post('/push/subscribe/', {
        subscription_info: subscription,
        browser: navigator.userAgent
      })
      
      console.log("🔔 Push configurato")
    } 
    catch (err) {

      console.error("Errore registrazione push:", err)
    }
  },

  urlBase64ToUint8Array(base64String) {

    const padding = '='.repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {

      outputArray[i] = rawData.charCodeAt(i)
    }

    return outputArray
  }
}